import axios from "axios"
import { buildAutorizationUrl, buildBaseUrl } from "./config"
import { makeArrayToast } from "../core/utils/toasts";
import { getFieldFromJwt } from "./utils";
import moment from "moment";




export async function getRolByAuthorizationBackend(jwt) {
  try {
    const authorizationResponse = await axios.post(buildAutorizationUrl(), { jwt });
    return authorizationResponse.data.message === "Unauthorized" ?
      null : authorizationResponse.data.rol || null;
  } catch (error) {
    console.error('Error en la solicitud a la uri: ' + buildAutorizationUrl(), error);
    return null;
  }
}


export async function validateJwt(jwt) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/validate`;

  try {
    const response = await axios.post(url, { jwt });
    if (response.status === 200) {
      console.log('Token validado correctamente:', response.data);
      return response.data;
    } else {
      console.error('Error al validar el token:', response.statusText);
      throw new Error('Error al validar el token');
    }
  } catch (error) {
    console.error('Error al realizar la solicitud POST:', error.message);
    throw error;
  }
}


export function getNit() {
  // Intentar obtener de la empresa activa en localStorage
  const activeCompanyStr = localStorage.getItem('activeCompany');
  if (activeCompanyStr) {
    try {
      const activeCompany = JSON.parse(activeCompanyStr);
      if (activeCompany && activeCompany.nit) {
        return activeCompany.nit;
      }
    } catch (e) {
      console.error('Error parsing activeCompany:', e);
    }
  }

  // Fallback al JWT tradicional
  return getFieldFromJwt('sub');
}

// Nueva función auxiliar para obtener todas las empresas disponibles
export function getAvailableCompanies() {
  return getFieldFromJwt('companies') || [];
}

// Nueva función para saber si es usuario multi-empresa
export function isMultiCompanyUser() {
  const companies = getAvailableCompanies();
  return companies.length > 1;
}


export async function getCompany() {
  return await getCompanyByNit(getNit());
}



export async function getDocuments(type, params = {}) {
  const { startDate, endDate, nit, uiid } = params;
  if (!nit) {
    params.nit = getNit();
  }

  /*
    Tipos de documento esperados:

    ANEXOS (CSV):
    - anexo:1  -> Anexo 1 - Ventas a contribuyentes
    - anexo:2  -> Anexo 2 - Ventas a consumidor final
    - anexo:3  -> Anexo 3 - Compras
    - anexo:5  -> Anexo 5 - Sujetos excluidos
    - anexo:8  -> Anexo 8 - Percepción del IVA 1% en compras
    - anexo:11 -> Anexo 11 - Anticipo de IVA 2% efectuado al declarante
    - anexo:13 -> Anexo 13 - Documentos legales anulados
    - donaciones -> Declaración de donaciones (no es anexo)

    LIBROS (PDF):
    - libro:contribuyente -> Libro de Contribuyente
    - libro:consumidor    -> Libro de Consumidor
    - libro:compras       -> Libro de Compras

    DOCUMENTOS INDIVIDUALES:
    - pdf:invoice  -> PDF de factura individual
    - json:invoice -> JSON de factura individual

    El parámetro 'params` puede tener:
    - startDate y endDate (para los anexos y libros)
    - nit (para pdf y libros)
    - uiid (para jsons y pdf)
  */

  let url = buildBaseUrl();
  let endpoint, typo;

  // Manejo especial para donaciones que no sigue el patrón endpoint:tipo
  if (type === 'donaciones') {
    url += `/documentos-tributarios/declaracion-donaciones`;
    endpoint = 'anexo'; // Tratarlo como anexo para el responseType
    typo = 'donaciones';
  } else {
    [endpoint, typo] = type.split(":");

    switch (endpoint) {
      case 'anexo':
        url += `/documentos-tributarios/anexo${typo}`;
        break;
      case 'libro':
        url += `/libros/libro-${typo}`;
        break;
      case 'libro-excel':
        url += `/libros/libro-${typo}-excel`;
        endpoint = 'libro'; // Tratarlo como libro para responseType blob
        break;
      case 'pdf':
        url += `/documentos-tributarios/pdf/${uiid}`;
        break;
      case 'json':
        url += `/documentos-tributarios/json/${uiid}`;
        break;
      default:
        throw new Error("Tipo de documento no válido.");
    }
  }

  /* 
    Formatear fechas con moment a 'YYYY-MM-DD' si se proporcionan
    ya que el backend lo recibe de esa manera
  */
  const queryParams = new URLSearchParams({
    nit: params.nit,
    fechaInicio: startDate ? moment(startDate).format('YYYY-MM-DD') : undefined,
    fechaFin: endDate ? moment(endDate).format('YYYY-MM-DD') : undefined
  }).toString();

  url += queryParams ? `?${queryParams}` : '';

  console.log("Esta es la URL: " + url);


  const config = {
    ...params
  };

  /* 
    Ajustar el responseType solo si es un libro por que es 
    un archivo pdf
  */
  if (endpoint === 'libro') {
    config.responseType = 'blob';
  }

  try {
    const response = await axios.get(url, config);
    console.log("Esto es el response: ", response);
    return response.data;
  } catch (error) {
    console.log("Error: ", error);
    return error.response?.data?.error ? error.response.data.error : `Ocurrió un error al tratar de leer los ${endpoint}s ${typo}`;
  }
}


/**funcion para listar usuarios */
export async function obtenerUsuarios(Nitcompany) {
  let url = buildBaseUrl();
  let nit = Nitcompany;
  try {
    const response = await axios.get(url + '/usuarios/nit/' + nit);
    console.log('URL completa:', response);
    return response.data;
  } catch (error) {
    console.error('Error al obtener los usuarios:', error);
    return [];
  }

};

// Función para obtener las empresas con paginación
export async function getCompanies({
  offset = 0,
  limit = 10,
  nombre_empresa,
  nit,
  sector,
  ciudad,
  pais,
  activo,
  count = false,
  execute_pagination = true,
} = {}) {
  const baseUrl = buildBaseUrl();
  let url = `${baseUrl}/companies?offset=${offset * limit}&limit=${limit}`;

  if (nombre_empresa) {
    url += `&nombre_empresa=${encodeURIComponent(nombre_empresa)}`;
  }
  if (nit) {
    url += `&nit=${encodeURIComponent(nit)}`;
  }
  if (sector) {
    url += `&sector=${encodeURIComponent(sector)}`;
  }
  if (ciudad) {
    url += `&ciudad=${encodeURIComponent(ciudad)}`;
  }
  if (pais) {
    url += `&pais=${encodeURIComponent(pais)}`;
  }
  if (activo !== undefined) {
    url += `&activo=${encodeURIComponent(activo)}`;
  }
  if (count) {
    url += `&count=true`;
  }
  if (!execute_pagination) {
    url += `&execute_pagination=false`;
  }

  try {
    console.log("esto es la url: ", url);
    const response = await axios.get(url);
    if (response.data && response.data.length > 0) {
      return response.data;
    } else {
      console.log('No se encontraron empresas.');
      if (response.data.totalRegistros !== undefined) {
        return response.data.totalRegistros;
      }
      return [];
    }
  } catch (error) {
    console.error('Error al obtener las empresas:', error);
    return [];
  }
}


export async function getLengthComapnies() {
  let baseUrl = buildBaseUrl();
  try {
    const url = baseUrl + `/companies`;

    const response = await axios.get(url);
    // Verificar si la respuesta contiene datos
    if (response.data && response.data.length > 0) {
      return response.data.length;
    } else {
      console.log('No se encontraron empresas.');
      return [];
    }
  } catch (error) {
    console.error('Error al obtener las empresas:', error);
    return [];
  }
}

export async function getCompanyByNit(nit) {
  let baseUrl = buildBaseUrl();
  try {
    const url = baseUrl + '/companies/' + nit;
    console.log('URL Compañia por Nit:', url);
    const response = await axios.get(url);
    // Verificar si la respuesta contiene datos
    if (response.data) {
      return response.data;
    } else {
      console.log('No se encontró la empresa con ese NIT.');
      return null;
    }
  } catch (error) {
    console.error('Error al obtener la empresa:', error);
    return null;
  }
}
/** Función para actualizar una empresa */
export async function actualizarEmpresa(nit, datosEmpresa) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/companies/${nit}`;

  try {
    const response = await axios.put(url, datosEmpresa);
    if (response.status >= 200 && response.status < 300) {
      console.log('Empresa actualizada correctamente:', response.data);
      return makeArrayToast(response.data.message ?
        response.data.message :
        "Empresa actualizada correctamente!", 1);
    } else {
      console.error('Error al actualizar la empresa:', response.statusText);
      return makeArrayToast('Hubo un error al actualizar la empresa', 1);
    }
  } catch (error) {
    console.error('Error al realizar la solicitud PUT:', error.message);
    return error.response && error.response.data && error.response.data.message ?
      makeArrayToast(error.response.data.message, 0) :
      makeArrayToast("Error desconocido, contacte con los devs", 0);
  }
}




/**Funcion Crear empresa */
export async function createCompany(companyData) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/companies`;
  try {
    const response = await axios.post(url, companyData);
    console.log("Company created successfully:", response);
    return response.status === 201 ?
      makeArrayToast(response.data.message ?
        response.data.message :
        "Empresa creada correctamente!", 1) :
      makeArrayToast('Hubo un error al crear la empresa', 1);
  } catch (error) {
    console.error('Error making POST request:', error);
    return error.response && error.response.data && error.response.data.message ?
      makeArrayToast(error.response.data.message, 0) :
      makeArrayToast("Error desconocido, contacte con los devs", 0);
  }
}

export async function actualizarEstadoEmpresa(nitEmpresa, isActive) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/companies/activate/${nitEmpresa}`;

  try {
    const response = await axios.put(url, { isActive });
    if (response.status >= 200 && response.status < 300) {
      console.log('Estado de la empresa actualizado correctamente:', response.data);
      return makeArrayToast(response.data.message, 1);
    } else {
      console.error('Hubo un error al actualizar el estado de la empresa:', response.statusText);
      return makeArrayToast('Error al actualizar el estado de la empresa', 1);
    }
  } catch (error) {
    console.error('Error al realizar la solicitud PUT:', error.message);
    return error.response && error.response.data && error.response.data.message ?
      makeArrayToast(error.response.data.message, 0) :
      makeArrayToast("Error desconocido, contacte con los devs", 0);
  }
}

/**Funciones para los enpoint de USUARIOS */
/* 
  Las respuestas de cada llamada de api deben de ser respondidas
  con un formato especifico, esto para que el dispash de show notification
  las capture y las pueda printiar en la pantalla

  Las respuestas de la api pueden ser:

  1. Un array (por multiples errores)
  2. Un string de todo bien (no siempre, controlar ese caso)
  3. Un string quemado de error

  el formato que espera el dispash es solamente un menssage
  y un codigo de error (0 fallo, 1 todo bien)
*/
export async function crearUsuario(datosUsuario) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/usuarios`;
  try {
    const response = await axios.post(url, datosUsuario);
    console.log("Esta es la verdadera respuesta: ", response);
    return response.status === 201 ?
      makeArrayToast(response.data.message, 1) :
      makeArrayToast('Hubo un error al crear el usuario', 1);
  } catch (error) {
    return error.response.data.message ?
      makeArrayToast(error.response.data.message, 0) :
      makeArrayToast("Error desconocido, contacte con los devs", 0);
  }
}


export function urlMenu() {
  const currentUrl = window.location.href;
  console.log(currentUrl);

  const url = currentUrl.split("/")
}

// Función para actualizar un usuario
export async function updateUser(email, nit, datosUsuario) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/usuarios/${encodeURIComponent(email)}/${encodeURIComponent(nit)}`;

  console.log("Datos del usuario: ", datosUsuario);

  try {
    const response = await axios.put(url, datosUsuario);

    if (response.status >= 200 && response.status < 300) {
      console.log('Usuario actualizado correctamente:', response.data);
      return makeArrayToast(response.data.message, 1);
    } else {
      console.error('Error al actualizar el usuario:', response.statusText);
      return makeArrayToast('Error al actualizar el usuario', 1);
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || "Error desconocido, contacte con los devs";
    console.error('Error al realizar la solicitud PUT:', error.message);
    return makeArrayToast(errorMessage, 0);
  }
}


export async function deleteUserByUsername(email, nit) {
  const emailEncoded = encodeURIComponent(email);
  const nitEncoded = encodeURIComponent(nit);
  const url = `${buildBaseUrl()}/usuarios/${emailEncoded}/${nitEncoded}`;
  try {
    const response = await axios.delete(url);
    console.log("Response delete user: ", response);
    return response.status === 200 ?
      makeArrayToast(`Usuario ${email} eliminado exitosamente.`, 1) :
      makeArrayToast('Error al eliminar el usuario', 1)
  } catch (error) {
    console.error(`Error al realizar la solicitud DELETE: ${error.message}`);
    return error.response && error.response.data && error.response.data.message ?
      makeArrayToast(error.response.data.message, 0) :
      makeArrayToast("Error desconocido, contacte con los devs", 0);
  }
}


export async function sendEmail(uiid) {
  const uiidEncoded = encodeURIComponent(uiid);
  const url = `${buildBaseUrl()}/documentos-tributarios/email/${uiidEncoded}`;
  try {
    const response = await axios.get(url);
    console.log("Esta es la respuesta: ", response);
    return response.status === 200 ?
      makeArrayToast(response.data.message, 1) :
      makeArrayToast('Error al mandar el email', 1)
  } catch (error) {
    console.error(`Error al realizar la solicitud DELETE: ${error.message}`);
    return error.response && error.response.data && error.response.data.message ?
      makeArrayToast(error.response.data.message, 0) :
      makeArrayToast("Error desconocido, contacte con los devs", 0);
  }
}


export async function getUserByEmail(email = null) {
  const emailUri = encodeURIComponent(email ? email : getEmailFromJwt());
  const url = `${buildBaseUrl()}/usuarios/email/${emailUri}`;
  try {
    console.log("esta es la urlL: ", url);
    const response = await axios.get(url);
    if (response.data && response.data.length > 0) {
      return response.data[0];
    } else {
      console.log('No se encontro el usuario.');
      console.log(response.data);
      if (response.data.totalRegistros) {
        return response.data.totalRegistros;
      }
      return [];
    }
  } catch (error) {
    console.error('Error al obtener las facturas:', error);
    return [];
  }
}




export async function getFacturas({
  offset = 0,
  limit = 100,
  count = false,
  fecha_desde,
  fecha_hasta,
  tipo_monto_mayor_que,
  tipo_monto_menor_que,
  tipo_monto_igual_que,
  fecha_dia,
  tipo_numero_documento_receptor,
  uuid = [],
  name_client,
  execute_pagination,
  order_by = 'desc',
  tipo_factura = [],
  anulado,
  certificado,
} = {}) {
  console.log("esto es el count ANTES: ", count);
  const baseUrl = buildBaseUrl();
  const nit = getNit();

  const buildQueryString = (params) => {
    return Object.entries(params)
      .filter(([_, value]) => value !== undefined && value !== null && value !== '')
      .map(([key, value]) => {
        return Array.isArray(value) ?
          value
            .filter(val => val !== undefined && val !== null && val !== '')
            .map(val => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
            .join('&') :
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      })
      .join('&');
  };


  console.log("esto es el count DESPUES: ", count);
  const commonQueries = {
    offset: offset * limit,
    limit,
    nit,
    count: count ? 'true' : '',
    fecha_desde,
    fecha_hasta,
    tipo_monto_mayor_que,
    tipo_monto_menor_que,
    tipo_monto_igual_que,
    fecha_dia,
    tipo_numero_documento_receptor,
    name_client,
    execute_pagination,
    order_by,
    anulado,
    certificado
  };

  if (uuid.length > 0) {
    commonQueries.uuid = uuid;
  }

  if (tipo_factura.length > 0) {
    commonQueries.tipo_factura = tipo_factura;
  }

  const fetchData = async (queryParams) => {
    console.log("esto es query params ", queryParams);
    const url = `${baseUrl}/documentos-tributarios/busqueda/facturas?${buildQueryString(queryParams)}`;
    console.log("Fetching URL: (" + count + ")", url);
    try {
      const response = await axios.get(url);
      return count ? response.data.totalRegistros : (response.data || []);
    } catch (error) {
      console.error('Error fetching facturas:', error);
      return [];
    }
  };

  return await fetchData(commonQueries);
}


export function getRolByJwt() {
  return getFieldFromJwt("role") || "default";
}

export function getJwt() {
  return localStorage.getItem('token');
}

export function getEmailFromJwt() {
  return getFieldFromJwt("username");
}

// ===== Funciones API para Contadores (Bookkeepers) =====

/**
 * Obtiene la lista de contadores de una empresa (owner)
 * @returns {Promise<Array>} Lista de contadores
 */
export async function getBookkeepers() {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/usuarios/bookkeepers`;
  try {
    const response = await axios.get(url);
    console.log('Contadores obtenidos:', response);
    return response.data;
  } catch (error) {
    console.error('Error al obtener los contadores:', error);
    return [];
  }
}

/**
 * Crea un nuevo contador
 * @param {Object} bookkeeperData - Datos del contador (nombre, email, companies[])
 * @returns {Promise<Array>} Respuesta con mensaje de éxito/error
 */
export async function createBookkeeper(bookkeeperData) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/usuarios/bookkeepers`;
  try {
    const response = await axios.post(url, bookkeeperData);
    console.log("Contador creado:", response);
    return response.status === 201 ?
      makeArrayToast(response.data.message || 'Contador creado exitosamente', 1) :
      makeArrayToast('Hubo un error al crear el contador', 0);
  } catch (error) {
    return error.response?.data?.message ?
      makeArrayToast(error.response.data.message, 0) :
      makeArrayToast("Error desconocido, contacte con los devs", 0);
  }
}

/**
 * Actualiza un contador existente
 * @param {string} id - ID del contador (_id)
 * @param {Object} bookkeeperData - Datos del contador a actualizar
 * @returns {Promise<Array>} Respuesta con mensaje de éxito/error
 */
export async function updateBookkeeper(id, bookkeeperData) {
  const baseUrl = buildBaseUrl();
  const url = `${baseUrl}/usuarios/bookkeepers/${encodeURIComponent(id)}`;

  console.log("Datos del contador a actualizar: ", bookkeeperData);

  try {
    const response = await axios.put(url, bookkeeperData);

    if (response.status >= 200 && response.status < 300) {
      console.log('Contador actualizado correctamente:', response.data);
      return makeArrayToast(response.data.message || 'Contador actualizado exitosamente', 1);
    } else {
      console.error('Error al actualizar el contador:', response.statusText);
      return makeArrayToast('Error al actualizar el contador', 0);
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || "Error desconocido, contacte con los devs";
    console.error('Error al realizar la solicitud PUT:', error.message);
    return makeArrayToast(errorMessage, 0);
  }
}

/**
 * Elimina un contador
 * @param {string} id - ID del contador a eliminar (_id)
 * @returns {Promise<Array>} Respuesta con mensaje de éxito/error
 */
export async function deleteBookkeeper(id) {
  const idEncoded = encodeURIComponent(id);
  const url = `${buildBaseUrl()}/usuarios/bookkeepers/${idEncoded}`;
  try {
    const response = await axios.delete(url);
    console.log("Response delete bookkeeper: ", response);
    return response.status === 200 ?
      makeArrayToast('Contador eliminado exitosamente.', 1) :
      makeArrayToast('Error al eliminar el contador', 0)
  } catch (error) {
    console.error(`Error al realizar la solicitud DELETE: ${error.message}`);
    return error.response?.data?.message ?
      makeArrayToast(error.response.data.message, 0) :
      makeArrayToast("Error desconocido, contacte con los devs", 0);
  }
}
